import { defineComponent as _defineComponent } from 'vue'
import {
  useI18n,
} from "@/composables/useI18n";

import {
  computed,
  PropType,
  ref,
  unref,
  watch,
} from "vue";

import type {
  Customer,
} from "@/components/customers/scripts/types";

import {
  maximumUriLength,
} from "@/scripts/Common/constraints/constraints";

import {
  isStringAndHasValue,
  isRequired,
  isSmallerOrEqualToMaxLength,
} from "@/scripts/Common/validators/defaultValidator";

import LogoEdit from "@/components/LogoEdit.vue";

import VueI18n from "vue-i18n";

import {
  createEmptyLogo,
} from "@/scripts/Common/helpers";

import {
  Logo,
} from "@/scripts/Common";


export default /*#__PURE__*/_defineComponent({
  __name: 'WebsiteEdit',
  props: {
  label: {
    required: true,
    type: String as PropType<string | VueI18n.TranslateResult>,
  },
  hasNoEditRights: {
    required: true,
    type: Boolean as PropType<boolean>,
  },
  model: {
    required: true,
    type: Object as PropType<Customer>,
  },
  expanded: {
    required: false,
    type: Array as PropType<number[]>,
    default() {
      return [1]
    }
  },
},
  emits: [
  'onValidChange',
  'update:isWebsitePartner',
  'update:websiteUrl',
  'update:logo',
],
  setup(__props, { emit: emits }) {

const props = __props;

const {
  t,
} = useI18n();





const valid = ref(true);
const logoValid = ref(true);
const internalExpand = ref(props.expanded);

const logo = computed(() => props.model?.websiteLogo ?? createEmptyLogo())

const websiteForm = ref();
const websiteLogo = computed(() => props.model?.websiteLogo);

const updateLogo = (value: Logo) => {
  emits('update:logo', value);

  if(websiteLogo.value?.data && websiteLogo.value?.format){
    logoValid.value = true;
  }
}
const isWebsitePartner = computed({
  get() {
    return props.model.isWebsitePartner
  },
  set(value: boolean) {
    emits('update:isWebsitePartner', value)
  }
})

const websiteUrl = computed({
  get() {
    return props.model.websiteUrl
  },
  set(value: string | undefined) {
    emits('update:websiteUrl', value)
  }
})

const validate = () => {
  if(websiteForm.value) websiteForm.value.validate();

  if (!isWebsitePartner.value) {
    logoValid.value = true;
    return
  }

  if(isStringAndHasValue(websiteLogo.value?.data) && isStringAndHasValue(websiteLogo.value?.format)){
    logoValid.value = true;
    return;
  }

  logoValid.value = false;
}

watch([valid, logoValid], () => {
  validate()
  emits('onValidChange', (unref(valid) && unref(logoValid)))
})

watch(() => props.expanded, () => {
  internalExpand.value = props.expanded
})

return { __sfc: true,t, props, emits, valid, logoValid, internalExpand, logo, websiteForm, websiteLogo, updateLogo, isWebsitePartner, websiteUrl, validate, maximumUriLength, isRequired, isSmallerOrEqualToMaxLength, LogoEdit }
}

})